<script>
  import UserInfo from "../../blocks/UserInfo.svelte";
  import type { IContact } from "../../blocks/UserInfo.svelte";

  interface IContactPanel {
    contacts: IContact[];
  }

  export let data: IContactPanel;
</script>

<section class="contact-panel g-centered">
  {#each data.contacts as item}
    <div class="contact">
      <UserInfo data={item} isLarge />
    </div>
  {/each}
</section>

<style lang="scss">
  .contact-panel {
    display: flex;
    flex-wrap: wrap;

    @include md {
      padding-bottom: 20px;
    }
  }

  .contact {
    display: flex;
    padding-right: 40px;
    flex: 1 0 100%;
    margin-bottom: 66px;

    @include sm {
      flex: 1 0 50%;
    }

    @media (max-width: 950px) {
      padding-right: 25px;
    }

    @include md-down {
      padding-right: unset;
    }
  }
</style>
